import { boolean, create, defaulted, object, string } from 'superstruct';
export const OPTIONS_TYPE = object({
  domain: defaulted(string(), 'EIP712Domain'),
  verifyDomain: defaulted(boolean(), true)
});
export const getOptions = options => {
  return create(options ?? {}, OPTIONS_TYPE);
};
//# sourceMappingURL=options.js.map